module.exports = __webpack_public_path__ + "static/media/logo-only-black.8463c5e0.svg";